var FIGURE = FIGURE || {};

// Clears the form-level "Please complete all required fields" line once the form is actually
// complete.
//
// That line is core markup (`p.whoops` in _forms/signup.tpl.php and its siblings), hidden by CSS and
// revealed only by `not-yet-sparky` on the form. The framework adds that class when a submit attempt
// fails and removes it only inside the success branch of a *later* submit attempt — nothing
// re-evaluates it while the user is fixing fields, so once it appears it sits there under a form full
// of green checkmarks until Submit is clicked again. On this site the reCAPTCHA button is an inline
// onclick rather than a form submit, so there isn't even a submit event to hang a fix off of.
//
// This is a local workaround. The real fix belongs in FIGURE.validateForm in OffsetBaseResources,
// where it would cover every client site and both the reCAPTCHA and plain submit paths — tracked as
// WEB-476. Delete this file and its require in javascript.js when that lands.
//
// The per-field .invalid-feedback messages are fine and are left alone: those are pure CSS off
// :invalid, so they already clear as the user types. Only the form-level line is stale.
FIGURE.formValidationMessage = function () {
    // Bound through jQuery rather than addEventListener because some of the framework code filling
    // these forms — place-autocomplete.js writing city/state/zip, for one — announces itself with
    // $(el).val(v).trigger("change"), and a jQuery-synthesized event never reaches a native listener.
    // Delegated from the document so forms loaded into a modal after page load are covered too.
    if (!window.jQuery) return;

    window.jQuery(document).on('input change', '.needs-validation', function () {
        // Only ever removed here, never re-added. The class means "your last submit attempt failed",
        // so emptying a field again shouldn't flash the message back up mid-edit — the next submit
        // will say so if it still applies.
        if (this.classList.contains('not-yet-sparky') && this.checkValidity()) {
            this.classList.remove('not-yet-sparky');
        }

        // `was-validated` deliberately stays put, so the per-field valid/invalid styling that the
        // failed submit turned on keeps working.
    });
}();
